import selectTimeButtonTpl from './select-time-button.tpl.html';
import './select-time-button.component.scss';
import normalButtonCompMod from '../../../common/material-components/buttons/normal-button.component';

import commonFilters from '../../common/filters';

class SelectTimeButtonComponent {
  constructor() {
    'ngInject';

    /**
     *
     * @type {?ReservationSlot}
     */
    this.time = null;

    /**
     * Language of the button used for localization of time formats.
     * @type {string}
     */
    this.lang = "";

    this.onPersonClicked = null;
    this.onLocationClicked = null;
  }

  _personClicked(time, event) {
    if (this.onPersonClicked != null) {
      event.preventDefault();
      this.onPersonClicked(time);
    }
  }

  _locationClicked(time, event) {
    if (this.onLocationClicked != null) {
      event.preventDefault();
      this.onLocationClicked(time);
    }
  }
}

const config = {
  templateUrl: selectTimeButtonTpl,
  controller: SelectTimeButtonComponent,
  bindings: {
    time: '<',
    lang: '@',
    onTimeSelected: '&',
    onPersonClicked: '&?',
    onLocationClicked: '&?',
    voucher: '<?',
    showFullTime: '<?'
  }
};

const mod = angular.module('app.reservation.select-time-button.component', [commonFilters, normalButtonCompMod])
.component('oralSelectTimeButton', config)
;

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/reservation/datetime/select-time-button.component.js